import ApiService from "@/core/services/ApiService";
import TokenService from "@/core/services/TokenService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface User {
  id: number;
  avatar: string;
  first_name: string;
  last_name: string;
  cellphone: string;
  email: string;
  password: string;
}

export interface Wallet {
  id: number;
  user_id: number;
  type: number;
  balance: number;
}

export interface UserAuthInfo {
  error: string;
  user: User;
  wallets: Wallet[];
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  error = "";
  user = {} as User;
  wallets = [];
  isAuthenticated = !!TokenService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Get current user Wallet object
   * @returns Wallet
   */
  get currentUserWallets(): Wallet[] {
    return this.wallets;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification error
   * @returns array
   */
  get getError(): string {
    return this.error;
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
    this.user.avatar = "/media/avatars/blank.png";
    this.wallets = user.wallets;
    this.isAuthenticated = true;
    this.error = "";
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.wallets = [];
    this.error = "";
    TokenService.destroyToken();
  }

  @Action
  [Actions.SIGN_IN]() {
    return new Promise<void>(() => {
      this.context.commit(Mutations.SET_AUTH, {});
    });
  }

  @Action
  [Actions.SIGN_OUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.VERIFY_AUTH]() {
    return new Promise<void>(() => {
      if (TokenService.getToken()) {
        ApiService.setHeader();
        ApiService.get("app/v2/profile")
          .then(({ data }) => {
            this.context.commit(Mutations.SET_USER, data);
          })
          .catch(() => {
            this.context.commit(Mutations.PURGE_AUTH);
          });
      } else {
        this.context.commit(Mutations.PURGE_AUTH);
      }
    });
  }
}
